import React from 'react';
import {Header} from "../components/Header";
import {CallToAction, Container, List, ListItem, StyledMedia} from "../styles/CommonStyler";
import {isMobileOnly} from "react-device-detect";
import Footer from "../components/Footer";
import {useSelector} from "react-redux";
import {FaqSection} from "../components/FaqSection";
import {FeatureCarousel} from "../components/FeatureCarousel";
import {Trans, useTranslation} from "react-i18next";
import {history} from "../_helpers";
import legal_img from "../../public/img/legal.png";
import arrow_above from "../images/arrow_above.svg";
import {sourceConstants} from "../_constants";
import IdentifierPlayer from "../components/player/identifierPlayer/IdentifierPlayer";
import {GetStartedPitch} from "../components/pitch/GetStartedPitch";

import {
    ButtonContainer,
    Content,
    ContentWrapper,
    Heading,
    Icon,
    Section,
    SubHeading,
    SubSection,
    SubSections,
    Title,
    TopDescriptionItem,
    VideoConstraint,
    VideoContainer,
    VideoPitch,
    VideoPitchIcon
} from "../styles/PromoPagesStyler"

export function Legal(){
    const user = useSelector(state => state.authentication ? state.authentication.user : undefined);
    const {t} = useTranslation("legal_landing");

    return (
        <StyledMedia>
            <Container isMobile={isMobileOnly}>
                <Header />
                
                <ContentWrapper>
                <Content>
                    <Section>
                        <SubSections flexDirection="row-reverse">
                            <SubSection flexGrow={1} align="flex-end">
                                <Icon src={legal_img} />
                            </SubSection>
                            <SubSection flexGrow={1.3}>
                                <Title>{t("Modernize legal processes, augmenting today’s one dimensional transcripts")}</Title>
                                <TopDescriptionItem><Trans i18nKey="tag-1">
                                    Effectively and remotely collaborate, creating and utilizing Gistify's <em>actionable
                                    transcripts</em> in a variety of legal settings. Gistify is a rolling abstract and
                                    keyword visualization built from your audio and video content that dramatically extends
                                    the usefulness of legal transcripts.
                                </Trans></TopDescriptionItem>
                                {!user &&
                                <TopDescriptionItem>
                                    <ButtonContainer>
                                        <CallToAction
                                            onClick={() => history.push('/signup')}>{t("Start Your Free Trial")}</CallToAction>
                                    </ButtonContainer>
                                </TopDescriptionItem>
                                }
                            </SubSection>
                        </SubSections>
                    </Section>

                    <Section>
                        <SubSections>
                            <VideoContainer>
                                <VideoConstraint>
                                    <IdentifierPlayer
                                        identifier={sourceConstants.SOURCE_DEFAULT.LEGAL}
                                    />
                                </VideoConstraint>
                            </VideoContainer>
                        </SubSections>
                    </Section>
                    <VideoPitch>{t('Try it out')}<VideoPitchIcon src={arrow_above} /></VideoPitch>

                    <Section>
                        <SubSections>
                            <SubSection align="center">
                                <FeatureCarousel/>
                                {!user &&
                                <ButtonContainer topPadded>
                                    <CallToAction
                                        onClick={() => history.push('/signup')}>{t("Start Your Free Trial")}</CallToAction>
                                </ButtonContainer>
                                }
                            </SubSection>
                            <SubSection>
                                <SubHeading>{t("Key Legal Uses & Benefits")}</SubHeading>
                                <p>{t("The first time you're able to find that key moment so easily, you may ask yourself why you'd not been using Gistify earlier.")}</p>
                                <List>
                                    <ListItem><Trans i18nKey={"key-use-1"}>Create an <em>actionable transcript</em> derived from any recorded media</Trans></ListItem>
                                    <ListItem>{t("Collaborate & record via Zoom")}</ListItem>
                                    <ListItem>{t("See and hear all parties on any device")}</ListItem>
                                    <ListItem>{t("Maintain social distancing")}</ListItem>
                                    <ListItem>{t("Effortless navigation")}</ListItem>
                                    <ListItem>{t("Share with your team")}</ListItem>
                                </List>
                                <p>{t("So, why are you still reviewing hardcopy transcripts?")}</p>
                            </SubSection>
                        </SubSections>
                    </Section>

                    <Section>
                        <SubSections>
                            <SubSection>
                                <FaqSection/>
                            </SubSection>
                        </SubSections>
                    </Section>

                    <Section>
                        <Heading>{t("Select Legal Use Cases")}</Heading>
                        <SubSections>
                            <SubSection>
                                <SubHeading>{t("Discovery")}</SubHeading>
                                <List>
                                    <ListItem>{t("Review witness interviews")}</ListItem>
                                    <ListItem>{t("Organize complex discovery")}</ListItem>
                                    <ListItem>{t("Make evidence more useful")}</ListItem>
                                </List>
                            </SubSection>
                            <SubSection>
                                <SubHeading>{t("Hearings & Deposition")}</SubHeading>
                                <List>
                                    <ListItem>{t("Easily reference testimony")}</ListItem>
                                    <ListItem>{t("Capture emotion & inflection")}</ListItem>
                                    <ListItem>{t("Playback for jury deliberation")}</ListItem>
                                </List>
                            </SubSection>
                            <SubSection>
                                <SubHeading>{t("Continuing Legal Education")}</SubHeading>
                                <List>
                                    <ListItem>{t("Effectively reference seminars")}</ListItem>
                                    <ListItem>{t("Increase productivity")}</ListItem>
                                    <ListItem>{t("Remain current")}</ListItem>
                                </List>
                            </SubSection>
                        </SubSections>
                    </Section>
                    
                </Content>
                </ContentWrapper>
                
                {!user &&
                <GetStartedPitch/>
                }
                
                <Footer />
            </Container>
        </StyledMedia>
    )
}